export default __webpack_public_path__ + "static/support-140fbd56ee5c102ef6cea8dad41ca769.jpg";